import { FormControl } from '@angular/forms';

export enum DocumentMimeType {
  DOC = 'doc',
  DOCX = 'docx',
  PDF = 'pdf',
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
}

export interface DocumentForm {
  document: FormControl<File | null>;
}

export interface DocumentItem {
  referenceId: string;
  dateUpload?: Date;
  uploadedAttachmentGroup: string;
  filename: string;
  type: string;
  typeDocument: string;
  path?: string;
}

export interface DocumentLabels {
  conditions: string[];
  fileError: string | Record<string, string>;
  apiError: string;
  uploadBox: {
    label: string;
    button: string;
  };
  download: string;
  file: string;
  delete: string;
  add: string;
  submit: string;
}
